import { render, staticRenderFns } from "./easy-loading.vue?vue&type=template&id=3c8fa0a6"
import script from "./easy-loading.vue?vue&type=script&lang=js"
export * from "./easy-loading.vue?vue&type=script&lang=js"
import style0 from "./easy-loading.vue?vue&type=style&index=0&id=3c8fa0a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports